define('rebrush/components/product/options',[
	'require',
	'jquery',
	'lodash',
	'cartware/components/Registry',
	'cartware/components/_base',
	'cartware/jquery/bem',
	'cartware/dom/event/trigger',
	'select2',
	'text!./options/templates/color.html',
	'text!./options/templates/badge.html'
], function(
	require,
	$,
	_,
	Registry,
	Component,
	BEM,
	triggerEvent,
	S2,
	ColorOptionTemplate,
	BadgeOptionTemplate
) {
	var templates = {
		color: _.template(ColorOptionTemplate),
		badge: _.template(BadgeOptionTemplate)
	};

	return Component.create({
		topOptionsBlock:			null,
		masterOptionsBlock:			null,

		topAttributesContainer:		null,
		masterAttributesContainer:	null,
		functionsContainer:			null,
		attributeContainers:		null,

		options:					null,

		$init: function() {
			this.viewBlock = BEM.block('product-view');
			this.topAttributesContainer = this.viewBlock.getElements('top-attributes-container');
			this.masterAttributesContainer = this.viewBlock.getElements('attributes-container');
			this.functionsContainer = this.viewBlock.getElements('functions-container');
			this.attributeContainers = this.masterAttributesContainer.add(this.functionsContainer);

			var optionsBlocks = BEM.block('product-options'),
				attributeLists = optionsBlocks.getElements('attribute-list');

			this.masterOptionsBlock = BEM.block(this.attributeContainers.find(optionsBlocks));

			this.topOptionsBlock = BEM.block(this.topAttributesContainer.find(optionsBlocks));

			this.masterAttributeList = this.masterOptionsBlock.find(attributeLists);
			this.topAttributeList = this.topOptionsBlock.find(attributeLists);

			this.optionHeadlines = this.masterOptionsBlock.getElements('attribute-headline');
			this.options = this.masterOptionsBlock.getElements('attribute-option');

			Registry().retrieve('product.view.configurable.spConfig', _.bind(this.initializeRendering, this));
		},

		initializeRendering: function() {
			var self = this;

			this.options.each(function() { self.initializeOptionElement(this); });

			this.optionHeadlines.first().appendTo(this.topAttributeList);
			this.options.first().appendTo(this.topAttributeList);

			if (!this.masterAttributeList.find(this.options).length) {
				var parentOptionsBlock = this.masterAttributeList.closest(BEM.block('product-options'));
				this.masterAttributeList.remove();
				var text = ''+parentOptionsBlock.html();

				text = text.replace(/(<script[^>]*>[\s\S]*?<\/script>)/gi, '');
				text = text.replace(/(<!--[^]*?-->)/gi, '');

				if (_.trim(text) === '') {
					parentOptionsBlock.bemAddModifier('empty');
				} else if (_.trim(parentOptionsBlock.text()) === '') {
					parentOptionsBlock.remove();
				}
			}

			this.hub.trigger('ui.component.rendering.after', {
				component: this
			});

			this.viewBlock.bemAddModifier('options-initialized');
		},

		initializeOptionElement: function(element) {
			element = $(element);

			var spConfig = window.spConfig,
				select = element.find('select'),
				value = select.val(),
				attributeCode = element.data('attribute-code'),
				attributeData = _.find(spConfig.config.attributes, function(attribute, attributeId) {
					return attribute.code === attributeCode;
				}),
				attributeExtension = _.find(spConfig.config.attribute_extensions, function(attribute, attributeId) {
					return attribute.code === attributeCode;
				}),
				renderer = _.get(attributeExtension, 'renderer', 'default'),
				template = _.get(templates, renderer),
				displayNode = $('<div class="display" />').prependTo(element),
				options = [],
				pubSubHub = this.hub;

			var setActiveValue = function(value) {
				displayNode
					.findBlock('super-attribute-select')
					.getElements('list-item')
					.bemRemoveModifier('active')
					.filter('[data-option="' + value + '"]')
					.bemAddModifier('active');
			};

			if (!template) {
				select.on('attribute/fillSelect', function() {
					triggerEvent(this, 'change');
				});

				select.on('change', function(e) {
					if ('undefined' === typeof e.originalEvent) {
						triggerEvent(this, 'change');
					}
				});

				$.fn.select2.amd.require(
					['select2/utils', 'select2/dropdown', 'select2/dropdown/attachContainer', 'select2/dropdown/closeOnSelect'],
					function (Utils, Dropdown, AttachContainer, CloseOnSelect) {
						select.select2({
							dropdownAdapter: Utils.Decorate(Utils.Decorate(Dropdown, AttachContainer), CloseOnSelect),
							width: '100%'
						});
					}
				);
			} else {
				element.on('click', '[data-option]', function() {
					var value = $(this).data('option');

					// todo: this seems to be called twice for no obvious reason

					//if ($(this).is(':modifier(disabled)')) return;

					select.val(value);
					triggerEvent(select, 'change');
				});

				select.on('change', function() {
					var value = select.val();

					if (!value) {
						return;
					}

					setActiveValue(value);
				});

				function render() {
					select.find('option').each(function() {
						var node = $(this),
							select = node.parent(),
							attributeId = select.prop('id').replace(/[a-z]*/, ''),
							value = node.prop('value'),
							option = {
								value: value,
								label: node.html(),
								tmpl: node.data('tmpl'),
								isEol: false,
							};

						if (!value) {
							return;
						}

						// get configurable super attribute options
						var configOptions = spConfig.config.attributes[attributeId].options;

						for (var i = 0, j = configOptions.length; i < j; i++) {
							if (configOptions[i].id == option.value) {

								var allowedSimples = _.pick(spConfig._configurable.simples, configOptions[i].allowedProducts);
								option.isEol = _.every(allowedSimples, 'is_eol');
								option.isIndexable = _.every(allowedSimples, 'is_search_engine_indexable');

								// preselect url
								if (option.isIndexable) {
									const simpleId = _.pick(configOptions[i].allowedProducts, 0);
									if (simpleId[0] !== undefined) {
										const preselectUrl = getPreselectUrl(simpleId[0]);
										option.preselectUrl = preselectUrl.href;
									}
								}

								if (configOptions[i].allowedProducts.length == 1
									&& _.get(spConfig, '_configurable.simples')
								) {
									for (var k in spConfig._configurable.simples) {
										if (k == configOptions[i].allowedProducts[0]) {
											// add child qty
											option.qty = spConfig._configurable.simples[k].qty;
										}
									}
								}
								break;
							}
						}

						_.forEach(spConfig.dataProviders, _.bind(function(provider) {
							if ('function' === typeof provider.provideSelectOption) {
								provider.provideSelectOption(option, select, attributeData.id);
							}
						},this));

						options.push(option);
					});

					function done() {
						element.bemAddModifier('rendered');
						displayNode
							.empty()
							.html(template({
								options: options,
								attribute: attributeData,
								attributeExtension: attributeExtension
							}));

						setActiveValue(select.val());
						pubSubHub.trigger('ui.change');
					}

					function getPreselectUrl(productId) {
						// add preselect url
						var currentUrl = window.location.href;
						// Remove trailing slash if present
						if (currentUrl.endsWith('/')) {
							currentUrl = currentUrl.slice(0, -1);
						}
						var preselectUrl = new URL(currentUrl);
						// add preselect param
						preselectUrl.searchParams.set('preselect', productId);

						return preselectUrl;
					}

					if (spConfig.dataProviders.length) {
						(function() {
							var i = 0, j = spConfig.dataProviders.length;

							function next(result) {
								var provider;

								options = result;

								if (i >= j) {
									done();
									return;
								}

								provider = spConfig.dataProviders[i];
								i++;

								if ('function' === typeof provider.sortSelectOptions) {
									options = provider.sortSelectOptions(options, attributeId);

									if ('object' === typeof options && 'then' in options) { // promise
										options.then(next);
									} else {
										next(options);
									}

									return;
								}

								next(options);
							}

							next(options);
						})();
					} else {
						done();
					}
				}

				render();
				select.on('attribute/fillSelect attribute/reloadOptionLabels', function() {
					options = [];
					render();
				});
			}

			if (value) {
				setActiveValue(value);
			}
		}

	});
});

